import { render } from "./SMSListPage.vue?vue&type=template&id=829e03a2"
import script from "./SMSListPage.vue?vue&type=script&lang=js"
export * from "./SMSListPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__